export enum WidgetPosition {
  bottomLeading = 'bottom-leading',
  bottomLeft = 'bottom-left',
  bottomRight = 'bottom-right',
  bottomTrailing = 'bottom-trailing',
  topLeading = 'top-leading',
  topLeft = 'top-left',
  topRight = 'top-right',
  topTrailing = 'top-trailing',
  manual = 'manual',
}
